import {autoserializeAs} from "dcerialize";

export class ReferenceCustomer {
  @autoserializeAs(() => String)
  public readonly name: string;
}
